module.exports = __webpack_public_path__ + "img/TESCO.a2d4287b.svg";